import { asyncRoute } from '../../router';

export default asyncRoute(() => import(/* webpackChunkName: "CalendarContainer" */ './container/CalendarContainer'));
